// @flow

/**
 * UrlTopNextPages.js - Редьюсер для изменения количества просмотров, заголовков и URL-ов TOP статей в хранилище
 * @module reducers/UrlTopNextPages
 * @requires module:constants/UrlTopNextPages
 * */

import {SET_TOP_NEXT_PAGES} from '../constants/UrlTopNextPages'

/**
 * @memberof reducers/UrlTopNextPages
 * */
type UrlTopNextPages = [{
    value: number,
    title: string,
    url: string,
    percent: number
}]

/**
 * @memberof reducers/UrlTopNextPages
 * */
type State = {
    urlTopNextPages: UrlTopNextPages
}

/**
 * @memberof reducers/UrlTopNextPages
 * */
type Action = {
    type: string,
    urlTopNextPages: UrlTopNextPages
}

/**
 * Начальное состояние
 * @memberof reducers/UrlTopNextPages
 * */
export const initialState: State = {
    urlTopNextPages: [{
        value: 0,
        title: '',
        url: '',
        percent: 0
    }]
}

/**
 * Возвращает новое состояние с данными о топе источников
 * @memberof reducers/urlTopNextPages
 * @function urlTopNextPages
 * @param {State} state
 * @param {Action} action
 * @return {State}
 * */
export default function urlTopNextPages(state: State = initialState, action: Action): State {
    switch (action.type) {
        case SET_TOP_NEXT_PAGES:
            return {...state, urlTopNextPages: [...action.urlTopNextPages]}

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/urlTopNextPages.js